<template>
    <div>
      <v-btn @click="triggerOverlayEvent">Trigger Event</v-btn>
    </div>
  </template>

<script>
export default {
  methods: {
    triggerOverlayEvent() {
    // Dispatchen der Daten an den Store
      const payload = {
        user: 'TestUser',
        event: 'Follow Event',
        audio: `${process.env.VUE_APP_BACKEND_PROTOCOL}://${process.env.VUE_APP_WS_URL}:${process.env.VUE_APP_WS_PORT}/sounds/follow.mp3`,
        image: `${process.env.VUE_APP_BACKEND_PROTOCOL}://${process.env.VUE_APP_WS_URL}:${process.env.VUE_APP_WS_PORT}/images/follow.png`,
      };

      // console.log('Daten werden dispatcht:', payload);
      this.$store.dispatch('updateOverlayData', payload);
    },
  },
};
</script>
